export const ADVISER_CATCH_UP_POINTS_OF_CONTACT = [
  "andre.oleary@rosemountfs.co.uk",
  "angel.strongitharm@rosemountfs.co.uk",
  "anne.sykes@rosemountfs.co.uk",
  "callum.wilkinson@rosemountfs.co.uk",
  "zachary.bawa@rosemountfs.co.uk",
];

export const PRIMARY_ADVISER_CATCH_UP_POINT_OF_CONTACT = "";
